export default {
  state: {
    scrollDirection: 'up',
  },
  mutations: {
    SET_SCROLL_DIRECTION(state, direction) {
      state.scrollDirection = direction
    },
  },
  getters: {
    GET_SCROLL_DIRECTION: (state) => state.scrollDirection,
  },
}
